import ReactPlayer from 'react-player';
import React, {FC, useContext, useRef, useState} from "react";
import Controls from "./Controls/Controls";
import screenful from "screenfull";
import {Box, Button} from "@mui/material";
import {NextWindowContext} from "../../context/NextWindowContext";

interface PlayerState {
    pip: boolean;
    playing: boolean;
    controls: boolean;
    light: boolean;
    muted: boolean;
    played: number;
    duration: number;
    playbackRate: number;
    volume: number;
    loop: boolean;
    seeking: boolean;
}

interface ReactPlayerComponentProps {
    data: any;
    collapsed: any;
    setCollapsed: (collapsed: boolean) => void;
    showNext?: boolean;
    isFinished?: boolean;
    lastLesson?: boolean;
}

export const ReactPlayerComponent: FC<ReactPlayerComponentProps> = ({lastLesson, isFinished, collapsed, setCollapsed, data, showNext = false}) => {
    const [timeDisplayFormat, setTimeDisplayFormat] = useState<string>("normal");
    const nextWindow = useContext(NextWindowContext)
    const [state, setState] = useState<PlayerState>({
        pip: false,
        playing: false,
        controls: false,
        light: false,
        muted: true,
        played: 0,
        duration: 0,
        playbackRate: 1.0,
        volume: 0.5,
        loop: false,
        seeking: false,
    });
    const [count, setCount] = useState<number>(0);
    const playerRef = useRef<ReactPlayer>(null);
    const playerContainerRef = useRef<HTMLDivElement>(null);
    const controlsRef = useRef<HTMLDivElement>(null);
    const canvasRef = useRef<HTMLCanvasElement>(null);

    const {
        playing,
        light, // video preview
        muted,
        loop,
        playbackRate,
        pip,
        played,
        volume,
    } = state;

    const handlePlayPause = () => {
        setState({ ...state, playing: !state.playing });
    };

    const handleRewind = () => {
        if (playerRef.current) {
            playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10);
        }
    };

    const handleFastForward = () => {
        if (playerRef.current) {
            playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10);
        }
    };

    const handleProgress = (changeState: any) => {
        if (count > 3) {
            if (controlsRef.current) controlsRef.current.style.visibility = "hidden";
            setCount(0);
        } else if (controlsRef.current && controlsRef.current.style.visibility === "visible") {
            setCount(count + 1);
        }
        if (!state.seeking) {
            setState({ ...state, ...changeState });
        }
    };

    const handleSeekChange = (value: number | number[]) => {
        playerRef.current?.seekTo(parseFloat(value.toString()));
        if (!playing) {
            setState({ ...state, playing: true });
        }
    };

    const handleSeekMouseDown = () => {
        setState({...state, seeking: true});
    };

    const handleSeekMouseUp = ( newValue: number | number[]) => {
        setState({...state, seeking: false});
        if (playerRef.current && typeof newValue === 'number') {
            playerRef.current.seekTo(newValue / 100, 'fraction');
        }
    };
    const handleVolumeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newVolume = parseFloat(event.target.value) / 100;
        setState({
            ...state,
            volume: newVolume,
            muted: newVolume === 0,
        });
    };
    const toggleFullScreen = () => {
        screenful.toggle(playerContainerRef.current as HTMLElement);
    };
    const handleMouseMove = () => {
        setCount(0);
        if (controlsRef.current) {
            controlsRef.current.style.visibility = "visible";
        }
    };

    const handleMouseLeave = () => {
        if (controlsRef.current) {
            controlsRef.current.style.visibility = "hidden";
        }
        setCount(0);
    };
    const handleDisplayFormat = () => {
        setTimeDisplayFormat(
            timeDisplayFormat === "normal" ? "remaining" : "normal"
        );
    };
    const handlePlaybackRate = (rate: number) => {
        setState({...state, playbackRate: rate});
    };
    const handleMute = () => {
        setState({...state, muted: !state.muted});
    };

    const format = (seconds: number) => {
        if (isNaN(seconds) || seconds < 0) {
            return `00:00`;
        }
        const date = new Date(seconds * 1000);
        const hh = date.getUTCHours();
        const mm = date.getUTCMinutes();
        const ss = date.getUTCSeconds().toString().padStart(2, "0");
        if (hh) {
            return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`;
        }
        return `${mm}:${ss}`;
    };

    const currentTime = playerRef.current ? playerRef.current.getCurrentTime() : 0;

    const duration = playerRef.current ? playerRef.current.getDuration() : 0;

    const elapsedTime = timeDisplayFormat === "normal"
        ? format(currentTime)
        : `-${format(duration - currentTime)}`;

    const totalDuration = format(duration);

    const fullScreen = screenful.isFullscreen;

    return (
        <div

            style={{
            position: "relative",
            width: "100%",
            height: fullScreen ? '500px' : '500px',
            background: "#808992",
        }}>
                <div
                    ref={playerContainerRef}
                    style={{height: "100%"}}
                    //onClick={(e) => handleVideoClick(e)}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                >
                    <ReactPlayer
                        ref={playerRef}
                        width='100%'
                        height='100%'
                        url={data.video}
                        pip={pip}
                        playing={playing}
                        controls={false}
                        light={light}
                        loop={loop}
                        playbackRate={playbackRate}
                        volume={volume}
                        muted={muted}
                        onProgress={handleProgress}
                        config={{
                            file: {
                                attributes: {
                                    crossOrigin: "anonymous",
                                },
                            },
                        }}
                    />
                    <div
                    >
                        <Controls
                            ref={controlsRef}
                            onPlayPause={handlePlayPause}
                            playing={playing}
                            onRewind={handleRewind}
                            onFastForward={handleFastForward}
                            toggleFullScreen={toggleFullScreen}
                            onPlaybackRateChange={handlePlaybackRate}
                            playbackRate={playbackRate}
                            onChangeDispayFormat={handleDisplayFormat}
                            elapsedTime={elapsedTime}
                            totalDuration={totalDuration}

                            onMute={handleMute}
                            muted={muted}
                            volume={volume}
                            onVolumeChange={handleVolumeChange}
                            played={played}
                            onSeek={handleSeekChange}
                            onSeekMouseDown={handleSeekMouseDown}
                            onSeekMouseUp={handleSeekMouseUp}
                            duration={duration}
                            timeDisplayFormat={timeDisplayFormat}
                            collapsed={collapsed}
                            setCollapsed={setCollapsed}

                        />
                    </div>

                {showNext &&
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: '20px',
                        padding: '0 20px'
                    }}
                >
                    <Button
                        className='close-modal-btn'
                        variant='contained'
                        onClick={() => {
                            nextWindow()
                        }}
                    >
                        {isFinished && lastLesson ? 'Завершить прохождение курса' : 'Далее'}
                    </Button>
                </Box>
                }
            </div>
            <canvas ref={canvasRef}/>
        </div>
    );
};
